











import Footer from '@/components/Footer.vue';
import Navbar from '@/components/Navbar.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Navbar,
    Footer,
  },
})
export default class App extends Vue {
  public created() {
    const fa = document.createElement('script');
    fa.setAttribute(
      'src',
      'https://use.fontawesome.com/releases/v5.0.7/js/all.js',
    );
    document.head.appendChild(fa);
  }
}
